import React, {useEffect, useRef, useState} from 'react'
import styles from './topListItem.module.scss'
import Fuse from 'Class/Fuse'
import IconItem from 'Components/UI/IconItem'
import Link from 'Components/UI/Link'
import LoadImage from 'Components/Layout/LoadImage'
import Spinner from 'Components/Feedback/Spinner'
import {StripTags} from 'Functions'

function TopListItem({
    className = '',
    dead =  false,
    description: descriptionFromProps = '',
    highlight = false,
    id,
    index,
    position = null,
    showEmoji = false,
    translate = false,
    type = null
})
{
    const [description, setDescription] = useState(descriptionFromProps)
    const [error, setError] = useState(false)
    const [image, setImage] = useState(null)
    const [loading, setLoading] = useState(false)
    const [title, setTitle] = useState('')
    const [url, setUrl] = useState('')
    const isMounted = useRef(true)
    const place = position === null ? index + 1 : position;
    const classNames = [
        styles.item,
        showEmoji && (place < 4 || dead) && styles.hasEmoji,
        highlight && styles.highlight + ' Highlight',
        className
    ].filter(c => !!c).join(' ')

    const renderPlace = (place) =>
    {
        if (!showEmoji)
        {
            return place;
        }
        if (dead)
        {
            return '💀';
        }
        switch (place)
        {
            case 1:
                return '🥇';
            case 2:
                return '🥈';
            case 3:
                return '🥉';
            default:
                return place;
        }
    }

    const loadContent = (id, translate) =>
    {
        if (!isMounted.current)
        {
            return;
        }
        setLoading(true)
        Fuse.Content(id, type, content =>
        {
            if (!isMounted.current)
            {
                return;
            }
            setLoading(false)

            if (!content?.type)
            {
                setError(true)
            } else {
                !descriptionFromProps && setDescription(StripTags(content?.description || ''))
                setError(false)
                setImage(content?.preview || null)
                setTitle(StripTags(content?.name || ''))
                setUrl(Fuse.ContentUrl(id, content.type))
            }
        }, translate)
    }

    useEffect(() => () => { isMounted.current = false }, [])

    useEffect(() => 
    {
        loadContent(id, translate)
    }, [id, translate])

    if (url)
    {
        return (
            <Link className={classNames + ' ' + styles.link} href={url}>
                <div className={styles.preview + ' ItemBackground'}>
                    {image && <LoadImage
                        className={styles.previewImage}
                        src={image}
                    />}
                    <span>{ renderPlace(place) }</span>
                </div>
                <div className={styles.content}>
                    <h4>{ title }</h4>
                    <p>{ description }</p>
                </div>
            </Link>
        )
    } else if (error) {
        return (
            <div className={classNames + ' ' + styles.error}>
                <div className={styles.preview + ' ItemBackground'}>
                    <span>{ renderPlace(place) }</span>
                </div>
                <div className={styles.content}>
                    <h4>Unable to load content</h4>
                    <IconItem
                        className={styles.retry}
                        feather="RefreshCw"
                        label="Try again"
                        loading={loading}
                        onClick={() => loadContent(id)}
                    />
                </div>
            </div>
        )
    } else {
        return (
            <div className={classNames}>
                <div className={styles.preview + ' ItemBackground'}>
                    <span>{ renderPlace(place) }</span>
                </div>
                <div className={styles.content}>
                    <h4>Loading...</h4>
                    <Spinner size={22} />
                </div>
            </div>
        )
    }
}

export default TopListItem